import { render, staticRenderFns } from "./ControlPreview.vue?vue&type=template&id=31d4e5d4&scoped=true&"
import script from "./ControlPreview.vue?vue&type=script&lang=js&"
export * from "./ControlPreview.vue?vue&type=script&lang=js&"
import style0 from "./ControlPreview.vue?vue&type=style&index=0&id=31d4e5d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d4e5d4",
  null
  
)

export default component.exports